import { connect } from "react-redux";
import ArticleCard from "../components/ArticleCard";
const mapStateToProps = (state) => {
    return {
        queryID: state.getIn(["searchData", "resultsState", "articles", "queryID"])
    };
};
const ArticleCardWithSubscription = connect(mapStateToProps)(ArticleCard);
export default ArticleCardWithSubscription;
